import { render, staticRenderFns } from "./merchantScreenCaste.vue?vue&type=template&id=4e72662a&scoped=true&"
import script from "./merchantScreenCaste.vue?vue&type=script&lang=js&"
export * from "./merchantScreenCaste.vue?vue&type=script&lang=js&"
import style0 from "./merchantScreenCaste.vue?vue&type=style&index=0&id=4e72662a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e72662a",
  null
  
)

export default component.exports